// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    export enum CostReviewOperation {
  SendReview = 0,
  CancelReview = 1,
  ReplaceReviewer = 2,
  RefreshReview = 3,
  UnlockReview = 4,
}
